import {
    getPendingClaims,
    getClaimById,
    generateClaim,
    closeClaim,
    submitClaim,
    bilClaimPmtTr,
    bilInvoicePmt,
    getSubmittedClaims,
    getClaimBatches,
    getClaimBatchById,
    submitClaimById,
    refreshClaim,
    resubmitClaim,
    editClaim,
    removeFromClaim,
    deleteClaim,
    getBillingOverview,
    getClaimAging,
    reSubmitClaim,
    getPendingClaimsTotal,
    getBillableClaimsTotal,
    changeClaimStatus,
    getCompletedClaimTotals,
    appealSubmittedClaim,
    markAsSecondaryBilling,
    cancelClaim,
    markAsReadySecondaryBilling,
    editReadySecondaryBilling,
    refreshApptUnits,
    checkClaimStatus,
    updateBillAdjustments,
} from './claim.action';

export { claimReducer } from './claim.reducer';
export { watchClaim } from './claim.saga';

export const claimActions = {
    getPendingClaims,
    getPendingClaimsTotal,
    getBillableClaimsTotal,
    getClaimAging,
    getCompletedClaimTotals,
    getSubmittedClaims,
    getClaimBatches,
    getClaimBatchById,
    getClaimById,
    generateClaim,
    editClaim,
    deleteClaim,
    changeClaimStatus,
    appealSubmittedClaim,
    /**Claim Status Actions */
    submitClaim,
    reSubmitClaim,

    submitClaimById,
    checkClaimStatus,
    cancelClaim,
    closeClaim,
    refreshClaim,
    resubmitClaim,
    removeFromClaim,
    /**Bill Details */
    bilClaimPmtTr,
    bilInvoicePmt,

    /** Overview */
    getBillingOverview,
    markAsSecondaryBilling,
    markAsReadySecondaryBilling,
    editReadySecondaryBilling,
    refreshApptUnits,
    updateBillAdjustments,
};
